import React, { useMemo, useState } from 'react';
import { Download } from 'lucide-react';
import { usePWAInstall } from '../utils/usePWAInstall';
import './modalStyles.css';

const InstallAppCTA = ({
  className = '',
  label = 'Install App',
  onBeforeCloseMenu
}) => {
  const { isIOS, isStandalone, isInstallable, promptInstall } = usePWAInstall();
  const [showIOSHelp, setShowIOSHelp] = useState(false);

  const shouldShow = useMemo(() => {
    // Hide if already installed/standalone
    if (isStandalone) return false;
    // Show if installable (Chrome/Edge/etc) OR iOS (needs instructions)
    return isInstallable || isIOS;
  }, [isStandalone, isInstallable, isIOS]);

  const handleClick = async () => {
    if (onBeforeCloseMenu) onBeforeCloseMenu();

    if (isInstallable) {
      await promptInstall();
      return;
    }

    if (isIOS) {
      setShowIOSHelp(true);
      return;
    }

    // Fallback for browsers without beforeinstallprompt
    alert('To install: open your browser menu and choose “Install App” / “Add to Home Screen”.');
  };

  if (!shouldShow) return null;

  return (
    <>
      <button className={className} onClick={handleClick}>
        <Download size={16} strokeWidth={2} className="menu-icon" />
        <span>{label}</span>
      </button>

      {showIOSHelp && (
        <div className="modal-overlay" onClick={() => setShowIOSHelp(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>Install SafeHer</h2>
              <button className="modal-close" onClick={() => setShowIOSHelp(false)}>×</button>
            </div>
            <div className="modal-body">
              <p style={{ marginTop: 0 }}>
                On iPhone/iPad, install SafeHer like this:
              </p>
              <ol style={{ paddingLeft: '18px', lineHeight: 1.6 }}>
                <li>Open this site in Safari</li>
                <li>Tap the Share button</li>
                <li>Select “Add to Home Screen”</li>
              </ol>
              <div className="form-actions">
                <button className="btn btn-primary" onClick={() => setShowIOSHelp(false)}>
                  Got it
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default InstallAppCTA;
